import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import MuiCardMedia, { CardMediaProps } from '@material-ui/core/CardMedia';

const CardMedia: React.FC<CardMediaProps> = withStyles((theme) => ({
  root: {
    overflow: 'hidden',
    position: 'relative',
    zIndex: 10,
    height: 120,
    [theme.breakpoints.up('sm')]: {
      height: 140,
    },
  },
}))(MuiCardMedia);

export default CardMedia;
